import { render, staticRenderFns } from "./secondClaimDialog.vue?vue&type=template&id=74ed5306&scoped=true"
import script from "./secondClaimDialog.vue?vue&type=script&lang=js"
export * from "./secondClaimDialog.vue?vue&type=script&lang=js"
import style0 from "./secondClaimDialog.vue?vue&type=style&index=0&id=74ed5306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ed5306",
  null
  
)

export default component.exports